










































































































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { CopyUrl } from "@/common/clipboard";
import { UsePopup } from "@/components/root/popup/popup.state";
import { InformationType } from "@/common/models";
import { remToPx } from "@/common/dom.functions";
export default Vue.extend({
  components: {
    AppTableRow,
    SensitivityLabel,
  },
  props: ["source"],
  setup(props) {
    const showPiisPopup = (piis: InformationType[], event: MouseEvent) => {
      UsePopup.showDisplayPopup({
        type: "TextDisplayPopup",
        event,
        items: piis.map((d) => d.labelName),
        position: "left",
        width: remToPx(30),
      });
    };
    return { CopyUrl, showPiisPopup };
  },
});
